import React from 'react'
import AdminBannerHome from '../../components/AdminSideComponents/AdminBanner/AdminBannerHome'

const AdminBanner = () => {
  return (
    <div className="bg-[#EEF3F7] p-6">
      <AdminBannerHome />
    </div>
  )
}

export default AdminBanner